export default __webpack_public_path__ + "static/media/img1.72417b43.jpg";